import React, { JSX, PropsWithChildren } from 'react';
import { NativeProps } from '@/src/components/interfaces';
import classNames from 'classnames';
import { CBox } from '@/src/components/c-box/CBox';

export interface CSwiperItemProps extends NativeProps {
}

export function CSwiperItem(props: PropsWithChildren<CSwiperItemProps>): React.JSX.Element {
  return (
    <CBox
      id={props.id}
      onClick={props.onClick}
      style={props.style}
      data-test-selector={props.testSelector ?? 'c-swiper__item'}
      class={classNames('c-swiper__item', props.class)}
    >
      {props.children}
    </CBox>
  );
}